import { styled } from "styled-components";

export const UserInfoWapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  border: 1px solid #383838;
  border-radius: 30px;
  padding: 24px;
`;
